module.exports = __webpack_public_path__ + "img/Ciara.1cff44f2.jpg";